import React, { useEffect, useState } from "react";
import { useCart } from "../context/UserCartCountContext";
import { Link, useNavigate } from "react-router-dom";
import { useNotification } from "../../Toast/ToastProvider";
import { calculateProductPrice, getCustomer, ratingAvg1 } from "../../include/function";
import "../../styles/CategoryProductList.css";
import {
  addToCartHandler,
  handleWishlist,
  loadCartData,
  loadWishlist,
} from "../../helper/cartUtils";
import * as Feather from "react-feather";
import { baseURL } from "../../include/api";

const CatProductListStyle = ({ product, fetchcart, cartData }) => {
  const [addedToCartMap, setAddedToCartMap] = useState({});
  const { fetchCartCount, setTotalWishlistItems } = useCart();
  const [loading, setLoading] = useState(null);
  const navigate = useNavigate();
  const toast = useNotification();
  const customer = getCustomer();
  const [wishlistProductIds, setWishlistProductIds] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [savedForLaterData, setSavedForLaterData] = useState({ products: [] });

  useEffect(() => {
    if (customer?.id) {
      loadCartData(customer.id, () => {}, setAddedToCartMap);
    }
  }, [customer?.id]);

  useEffect(() => {
    if (customer?.id) {
      loadWishlist(
        customer.id,
        setWishlistProductIds,
        setTotalWishlistItems,
        setFetchLoading,
      );
    }
  }, [customer?.id, setTotalWishlistItems]);

  useEffect(() => {
    const handleCartUpdate = () => {
      if (customer?.id) {
        loadCartData(customer.id, () => {}, setAddedToCartMap);
      }
    };

    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, [customer?.id, setAddedToCartMap]);

  useEffect(() => {
    const handleWishlistUpdate = () => {
      if (customer?.id) {
        loadWishlist(
          customer.id,
          setWishlistProductIds,
          setTotalWishlistItems,
          () => {},
        );
      }
    };

    window.addEventListener("wishlistUpdated", handleWishlistUpdate);
    return () =>
      window.removeEventListener("wishlistUpdated", handleWishlistUpdate);
  }, [customer?.id, setWishlistProductIds, setTotalWishlistItems]);

  const handleAddToCart = (product) => {
    addToCartHandler({
      product,
      customer,
      setAddedToCartMap,
      setSavedForLaterData,
      fetchCartCount,
      toast,
      navigate,
      setLoading,
      savedForLaterData,
    });
  };

  // Wishlist Handler
  const wishListHandler = async (item) => {
    if (loading === item.productId) return;

    setLoading(item.productId);
    await handleWishlist({
      item,
      customer,
      wishlistProductIds,
      setWishlistProductIds,
      setTotalWishlistItems,
      toast,
    });
    setLoading(null);
  };

  const isAdded = !!addedToCartMap[product.productId];

  const priceInfo = calculateProductPrice(product);

  return (
    <div className="product-card1 h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
      <div className="d-flex flex-row justify-content-center align-items-center">
        <div
          className=" bg-gray-50"
          style={{
              height: "190px",
            display:'flex',
            alignItems: "center",
            backgroundColor: "#F1F1F1",
            borderRadius:"8px",
            justifyContent:"center"
          }}
        >
          <Link
            to={`/product-details/${product.productId}`}
            className="product-card__thumb bg-gray-50 flex-center rounded-8  position-relative"
          >
            {product.discountLabel && (
              <span className="product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                {product.discountLabel}
              </span>
            )}
            <img
              src={baseURL + "/" + product.mainImage || product.imageUrl}
              alt=""
            />
          </Link>
        </div>

        <div className="flex-grow-1 ps-40">
          <div className="d-flex justify-content-between mb-16">
            <div className="d-flex align-items-center gap-1">
              {product?.ratingAndReview?.length > 0 ? (
                <>
                  <div
                    className="badge bg-success text-white d-inline-flex align-items-center"
                    style={{ fontSize: "13px" }}
                  >
                    {ratingAvg1(product.ratingAndReview)}
                    <i className="ph-fill ph-star ms-1" />
                  </div>
                  <span
                    className="fw-medium text-gray-500"
                    style={{ fontSize: "13px" }}
                  >
                    ({product.ratingAndReview.length})
                  </span>
                </>
              ) : (
                <div></div>
              )}
            </div>

            <div
              className="d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                wishListHandler(product);
              }}
              disabled={loading === product.productId}
            >
              {loading === product.productId ? (
                <div
                  className="spinner-border spinner-border-sm text-secondary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : wishlistProductIds.includes(String(product.productId)) ? (
                <Feather.Heart
                  fill="red"
                  color="red"
                  size={22}
                  strokeWidth={1.6}
                />
              ) : (
                <Feather.Heart size={22} strokeWidth={1.6} />
              )}
            </div>
          </div>
          <div className="list-product-content">
            <h6
              className="title text-lg text-capitalize fw-semibold mb-8 w-75"
              style={{
                height: "3em",
                overflow: "hidden",
              }}
            >
              <Link
                to={`/product-details/${product.productId}`}
                className="link"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%",
                  lineHeight: "1.5em",
                }}
                tabIndex={0}
              >
                {product.name}
              </Link>
            </h6>

            <div className="flex-align gap-4">
              <span className="text-tertiary-600 text-md d-flex">
                <i className="ph-fill ph-storefront" />
              </span>
              <span className="text-gray-500 text-xs">By PTC</span>
            </div>
            <div className="mt-8 w-100">
              <div
                className="progress bg-color-three rounded-pill h-4"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow={35}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{ width: "75%" }}
              >
                <div
                  className="progress-bar bg-tertiary-600 rounded-pill"
                  style={{ width: "35%" }}
                />
              </div>
              <span className="text-gray-900 text-xs fw-medium mt-8">
                Sold: 18/35
              </span>
            </div>
            <div className="list-product-price my-20">
              {priceInfo.priceType === "productVariant" ? (
                <>
                  <div className="text-gray-400 text-md fw-semibold text-decoration-line-through mb-2">
                    {priceInfo.retailPriceDisplay}
                  </div>
                  <div className="text-heading text-md fw-semibold">
                    {priceInfo.sellingPriceDisplay}
                  </div>
                </>
              ) : (
                <>
                  {priceInfo.originalPrice && (
                    <div className="text-gray-400 text-md fw-semibold text-decoration-line-through mb-2">
                      ₹ {priceInfo.originalPrice}
                    </div>
                  )}
                  <span className="text-heading text-md fw-semibold">
                    ₹ {priceInfo.displayPrice}
                    {priceInfo.qtyRange && (
                      <span className="text-gray-500 fw-normal ms-2">
                        ({priceInfo.qtyRange})
                      </span>
                    )}
                    <span className="text-gray-500 fw-normal">
                      {priceInfo.priceType === "qtyAndPrice" ? "" : "/Qty"}
                    </span>
                  </span>
                </>
              )}
            </div>
            <button
              className={`list-product-cart btn py-11 px-24 rounded-8 flex-center gap-8 fw-medium ${
                isAdded
                  ? "bg-main-600 text-white"
                  : "bg-gray-50 text-heading hover-bg-main-600 hover-text-white"
              }`}
              onClick={() => {
                if (isAdded) {
                  navigate("/cart");
                } else {
                  handleAddToCart(product);
                }
              }}
              disabled={loading === product.productId}
            >
              {loading === product.productId ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Loading...</span> Adding...
                </>
              ) : isAdded ? (
                "\u00A0\u00A0Go To Cart"
              ) : (
                "Add To Cart"
              )}
              <i className="ph ph-shopping-cart" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatProductListStyle;
